@for (color of colors; track color) {
  <bn-web-ui-color-picker-color
    [color]="color"
    [selectedColor]="selectedColor"
    (click)="handleColorClick(color)" />
}
